<template>
    <main class="content">
        <div class="row">
            <h1>
                Edit Wall
            </h1>
        </div>
        <form action="" class="form">
            <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>

            <fieldset class="form--item">
                <label class="label" for="">
                    Name:
                </label>
                <div class="input_text">
                    <input name="" v-model="wall.name" placeholder="Write a wall name" type="text" value="Bowers & Houston St"/>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="">
                    City:
                </label>
                <div class="input_text">
                    <v-select v-model="cityId" required :searchable="false" placeholder="Choose a city" :options="cities"></v-select>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="">
                    Address:
                </label>
                <div class="input_text">
                    <input name="" v-model="wall.address" placeholder="Write an address" type="text" value="294 Bowery"/>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="">
                    Zip code:
                </label>
                <div class="input_text">
                    <input name="" v-model="wall.zipcode" placeholder="Write a zip code" type="text" value="10012"/>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="">
                    Agent email address:
                </label>
                <div class="input_text">
                    <input name="" v-model="agentEmail" placeholder="Write an email address" type="text"/>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="picture">
                    Picture:
                </label>
                <div class="form--item_img-wrapper">
                  <div class="form--item_img" id="preview_image"></div>
                  <label class="input_file" for="picture"  id="picture_choose">
                      <span class="btn btn_grey">
                          Choose file
                      </span>
                      <input v-on:change="setPicture" required id="picture" name="picture" type="file"/>
                  </label>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="">
                    About Wall:
                </label>
                <div class="input_text input_text_long">
                    <textarea name="" v-model="wall.wallDescription" placeholder="Write a zip code" type="text" value="Located at one of the busiest downtown intersections in Manhattan, this is truly an iconic wall. Surrounded by hip hotels, restaurants, galleries, and other stylish retail, it boasts a projection screen area of about 70x35’ (22x11m). It is available year-round">
                    </textarea>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="">
                    Add Wall Location pin:
                </label>
                <div class="location--wrapper">
                    <gmap-map
                      :center="wall.location"
                      :zoom="16"
                      map-type-id="terrain"
                      style="width: 500px; height: 300px"
                    >
                      <gmap-marker
                        :position="wall.location"
                        :clickable="true"
                        :draggable="true"
                        @dragend="dragend($event)"
                        :icon="'static/images/gm_pin.png'"
                      ></gmap-marker>

                    </gmap-map>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="">
                    Create new password
                </label>
                <div class="input_text">
                    <input name="" v-model="wall.password" placeholder="Choose a password" type="password" value="WalltimeisDope2017"/>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="">
                    Screen saver:
                </label>
                <div class="input_text">
                    <v-select v-model="screensaverId" required :searchable="false" placeholder="Pick a screensaver" :options="screensavers"></v-select>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="">
                    Webcams:
                </label>
                <div class="inputGroup">
                    <label class="inputGroup--label" for="input8">
                        Webcam 1
                    </label>
                    <div class="input_text">
                        <input id="input8" v-model="webcam_1" name="" placeholder="Paste a URL link from Ustream" type="text" value="http://ustream/58ae17c50119028a1e16a7d4"/>
                    </div>
                </div>
                <div class="inputGroup">
                    <label class="inputGroup--label" for="input9">
                        Webcam 2
                    </label>
                    <div class="input_text">
                        <input id="input9" v-model="webcam_2" name="" placeholder="Paste a URL link from Ustream" type="text" value=""/>
                    </div>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="">
                    Basis price per 6 seconds:
                </label>
                <div class="input_text">
                    <input name="" v-model="wall.basePricing" placeholder="1$" type="text" value=""/>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="">
                    Princing blocks:
                    <span>
                        (Any timeslot which is not covered will apply the basis price).
                    </span>
                </label>
                <div v-for="block in wall.pricingModifiers">
                  <div class="input_text">
                      <input name="" type="text" :value="formatPriceBlock(block)"/>
                  </div>
                  <div class="row7">
                      <a class="btn btn_half btn_blueLight u-fleft" @click="editPriceBlock(block)">
                          Edit
                      </a>
                      <a class="btn btn_half btn_red u-fleft" @click="deletePriceBlock(block)">
                          Delete
                      </a>
                  </div>
                </div>
                <div class="row7">
                    <a class="btn row7--add u-fleft" @click="togglePriceBlock()">
                        Add new pricing block
                    </a>
                </div>
            </fieldset>
            <fieldset class="form--item divider">
                <label class="label" for="">
                    Recurring blocked timeslots:
                </label>
                <div v-for="block in wall.recurringBlockedTimeslots">
                  <div class="input_text">
                      <input name="" @click="editRecurringBlockedTimeslotBlock(block)" class="pointer" type="text" :value="block.formatted_value" readonly="true" />
                  </div>
                  <div class="row7">
                      <button class="btn btn_half btn_blueLight u-fleft" @click="editRecurringBlockedTimeslotBlock(block)" type="button">
                          Edit
                      </button>
                      <button class="btn btn_half btn_red u-fleft" @click="deleteRecurringBlockedTimeslotBlock(block)" type="button">
                          Delete
                      </button>
                  </div>
                </div>
                <div class="row7">
                    <button class="btn row7--add u-fleft" @click="toggleRecurringBlockedTimeslotBlock()" type="button">
                        Add new recurring blocked timeslot
                    </button>
                </div>
            </fieldset>
            <div class="row7">
                <a class="btn btn_half btn_green u-fleft u-mr1" @click="updateWall()">
                    Update
                </a>
                <a class="btn btn_half btn_red u-fleft" @click="confirmToggle()">
                    Delete
                </a>
            </div>
        </form>
        <confirm resource="wall" :visible.sync="alertVisible"></confirm>
        <ok resource="wall" resource-plural="walls" :visible.sync="okVisible"></ok>
        <price :visible.sync="priceVisible" :block="block"></price>
        <recurringBlockedTimeslot :visible.sync="recurringBlockedTimeslotVisible" :block="block"></recurringBlockedTimeslot>
        <loading :visible.sync="loadingVisible"></loading>
    </main>
</template>
<script>
  import * as EditResource from '../../mixins/editResource.mixin';
  import * as HttpService from '../../services/http.service'

  import Confirm from '../Modals/modal_confirm';
  import Ok from '../Modals/modal_ok';
  import vSelect from "vue-select"
  import Price from '../Modals/modal_price';
  import RecurringBlockedTimeslot from '../Modals/modal_recurring_blocked_timeslot';
  import Message from '../Message';
  import Loading from '../Loading';
  import * as ValidateForm from '../../mixins/validate-form.mixin';

  var moment = require('moment');
  export default {
    name: 'EditWalls',
    components: {
      Confirm,
      Ok,
      vSelect,
      Price,
      RecurringBlockedTimeslot,
      Message,
      Loading
    },
    mixins: [EditResource, ValidateForm],

    data() {
      return {
        model: 'wall',
        resource: 'walls',
        parentResource: 'Walls',
        alertVisible: false,
        okVisible: false,
        wall: {
          location: {
            lat: 40.7128,
            lng: -74.0059
          }
        },
        required_fields: [{
            'attribute': 'wall.name',
            'message': 'Name is missing',
            'id': 'name'
          },
          {
            'attribute': 'cityId.value',
            'message': 'City is missing',
            'id': 'cityId'
          },
          {
            'attribute': 'wall.address',
            'message': 'Address is missing',
            'id': 'address'
          },
          {
            'attribute': 'wall.zipcode',
            'message': 'Zipcode is missing',
            'id': 'zipcode'
          },
          {
            'attribute': 'wall.wallDescription',
            'message': 'Description is missing',
            'id': 'wallDescription'
          },
          {
            'attribute': 'wall.basePricing',
            'message': 'Base pricing is missing',
            'id': 'basePricing'
          },
          {
            'attribute': 'screensaverId',
            'message': 'ScreenSaver is missing',
            'id': 'screensaverId'
          }
        ],
        email: '',
        cityId: '',
        screensaverId: '',
        errorMessage: '',
        webcam_1: '',
        webcam_2: '',
        picture: {},
        screensavers: [],
        cities: [],
        priceVisible: false,
        recurringBlockedTimeslotVisible: false,
        block: {},
        days: [{
            value: 0,
            label: "Sunday"
          },
          {
            value: 1,
            label: "Monday"
          },
          {
            value: 2,
            label: "Tuesday"
          },
          {
            value: 3,
            label: "Wednesday"
          },
          {
            value: 4,
            label: "Thursday"
          },
          {
            value: 5,
            label: "Friday"
          },
          {
            value: 6,
            label: "Saturday"
          }
        ]
      }
    },
    created() {
      var self = this;
      HttpService.index('screensavers', {}, function(response, error) {
        self.screensavers = response.result.data;

        self.screensavers = self.screensavers.map(item => {
          return {
            value: item.id,
            label: item.videoDetails.title
          }
        });
      });

      HttpService.index('cities', {}, function(response, error) {
        self.cities = response.result.data;
        self.cities = self.cities.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        });
      });
    },
    mounted() {
      this.fetchResource(this.$route.params.id, {});
    },
    computed: {
      agentEmail: {
        get: function () {
          if (this.wall.agent != null) {
            return this.wall.agent.email;
          } else {
            return '';
          }
        },
        set: function (value) {
          this.email = value;
        }
      }
    },
    methods: {
      togglePriceBlock() {
        this.priceVisible = !this.priceVisible;
        this.block = {};
      },
      deletePriceBlock(block) {
        this.wall.pricingModifiers = this.wall.pricingModifiers.filter(function(item) {
          return item.id != block.id
        });
        this.block = {};
      },
      editPriceBlock(block) {
        this.block = block;
        this.priceVisible = true;
      },
      convertTimeslot(datetime) {
        let value = ("00" + Math.floor(parseInt(datetime) / 4)).slice(-2) + ":" + ("00" + (parseInt(datetime) * 15) % 60).slice(-2)
        return value
      },
      formatPriceBlock(val) {
        val.starttime = this.convertTimeslot(val.startSlot);
        val.endtime = this.convertTimeslot(val.endSlot);
        return moment(val.starttime, "hh:mm").format("hh:mma") + ' to ' + moment(val.endtime, "hh:mm").format("hh:mma") + ' - x' + val.multiplier;
      },
      addPriceBlock(block) {
        let index = this.wall.pricingModifiers.find(item => item.id == block.id);
        if (index) {
          for (var i = this.wall.pricingModifiers.length - 1; i >= 0; i--) {
            if (this.wall.pricingModifiers[i].id == block.id) {
              this.wall.pricingModifiers[i] = block;
              break;
            }
          }
        } else {
          this.wall.pricingModifiers.push(block);
        }
        this.priceVisible = false;
        this.block = {};
      },
      toggleRecurringBlockedTimeslotBlock() {
        this.recurringBlockedTimeslotVisible = !this.recurringBlockedTimeslotVisible;
        this.block = {};
      },
      deleteRecurringBlockedTimeslotBlock(block) {
        this.wall.recurringBlockedTimeslots = this.wall.recurringBlockedTimeslots.filter(function(item) {
          return item.id != block.id
        });
        this.block = {};
      },
      editRecurringBlockedTimeslotBlock(block) {
        this.block = block;
        this.recurringBlockedTimeslotVisible = true;
      },
      addRecurringBlockedTimeslotBlock(block) {
        let index = this.wall.recurringBlockedTimeslots.find(item => item.id == block.id);
        if (index) {
          for (var i = this.wall.recurringBlockedTimeslots.length - 1; i >= 0; i--) {
            if (this.wall.recurringBlockedTimeslots[i].id == block.id) {
              this.wall.recurringBlockedTimeslots[i] = block;
              break;
            }
          }
        } else {
          this.wall.recurringBlockedTimeslots.push(block);
        }
        this.recurringBlockedTimeslotVisible = false;
        this.block = {};
      },
      formatRecurringBlockedTimeslotBlock(val) {
        return this.days[val.dayId].label + " - " + moment(val.starttime, "hh:mm").format("hh:mma") + ' to ' + moment(val.endtime, "hh:mm").format("hh:mma");
      },
      getTimeslot(datetime) {
        let time = datetime.split(":");
        let slot = time[0] * 4 + time[1] / 15;

        return ("00" + slot).slice(-2);
      },
      dragend(e) {
        this.wall.location = {
          lat: e.latLng.lat(),
          lng: e.latLng.lng()
        };
      },
      setPicture(e) {
        var files = e.target.files || e.dataTransfer.files;
        this.picture = files[0];
        this.generatePreview();
      },
      generatePreview() {
        var reader = new FileReader();
        reader.onload = function(e) {
          $('#preview_image').css('background-image', 'url(' + e.target.result + ')').show();
        }
        reader.readAsDataURL(this.picture);
      },
      updateWall() {
        var self = this;
        if (this.validate()) {
          self.wall.cityId = self.cityId.value || self.wall.cityId || self.wall.city.id;
          self.wall.screensaverId = self.screensaverId.value || self.wall.screensaverId || self.wall.screensaver.id;
        } else {
          return false
        }

        self.wall.webcams = [];
        if (self.webcam_1) {
          self.wall.webcams.push({ originalLink: self.webcam_1 });
        }

        if (self.webcam_2) {
          self.wall.webcams.push({ originalLink: self.webcam_2 });
        }

        // Format recurring blocked timeslots
        var weeklyBlocking = {};
        for (var i in self.wall.recurringBlockedTimeslots) {
          let slot = self.wall.recurringBlockedTimeslots[i];
          if (!weeklyBlocking.hasOwnProperty(slot.dayId.toString())) {
            weeklyBlocking[slot.dayId.toString()] = [];
          }
          weeklyBlocking[slot.dayId.toString()].push({
            startSlot: parseInt(slot.startSlot),
            endSlot: parseInt(slot.endSlot)
          });
        }
        self.wall.weeklyBlocking = weeklyBlocking;

        var params = JSON.parse(JSON.stringify(self.wall));

        delete params.screensaver;
        delete params.city;
        delete params.picture;
        delete params.recurringBlockedTimeslots;
        delete params.agent;

        var data = new FormData();
        for (var i in params) {
          let val = params[i];
          if (typeof val == "object")
            val = JSON.stringify(params[i]);
          data.append(i, val);
        }

        if (this.picture.name)
          data.append('picture', this.picture);
        self.loadingVisible = true;
        HttpService.update('walls', this.wall.id, data, function(response, error) {
          if (error) {
            self.errorMessage = error.message;
            self.loadingVisible = false;
          } else if(self.email !== '') {
            self.updateAgent(self.wall.id);
          } else {
            self.$router.push({
              name: 'Walls'
            });
            self.loadingVisible = false;
          }
        });
      },
      updateAgent(wallId){
        var self = this;
        const body = {
          agentEmail: self.email
        }
        HttpService.update('agents/setwall/' + wallId, '', body, function(response, error) {
          if (error) {
            self.errorMessage = error.message;
          } else {
            self.$router.push({
              name: 'Walls'
            });
          }
          self.loadingVisible = false;
        });
      }
    },
    watch: {
      'wall.screensaver.id': function(val, change) {
        this.screensaverId = this.screensavers.find(item => item.value == this.wall.screensaver.id);
      },
      'screensavers': function(val, change) {
        if (this.wall.screensaver)
          this.screensaverId = this.screensavers.find(item => item.value == this.wall.screensaver.id);
      },
      'wall.city.id': function(val, change) {
        this.cityId = this.cities.find(item => item.value == this.wall.city.id);
        try {
            if (this.wall.liveViews.length) {
                this.webcam_1 = this.wall.liveViews[0].originalLink || '';
                this.webcam_2 = this.wall.liveViews[1].originalLink || '';
            }
        }
        catch(_) {
            this.webcam_1 = this.wall.webcams[0] || '';
            this.webcam_2 = this.wall.webcams[1] || '';
        }
      },
      'cities': function(val, change) {
        if (this.wall.city)
          this.cityId = this.cities.find(item => item.value == this.wall.city.id);
      },
      'wall.picture.url': function(val, change) {
        this.picture = val + '?api_key=' + this.$parent.api_key;
        $('#preview_image').css('background-image', 'url(' + this.picture + ')').show();
      },
      'wall.id': function(val, change) {
        this.wall.basePricing = parseFloat(this.wall.basePricing).toFixed(2);

        var slots = [];

        let keys = ["0", "1", "2", "3", "4", "5", "6"];
        let times = []
        for (var i = 0; i < 24 * 4; i++) {
          let date = moment(0, "HH:mm").add(i * 15, "minutes").format("HH:mm");
          times.push(date);
        }
        keys.forEach(key => {
          let weeklyBlockingSlots = this.wall.weeklyBlocking[key];
          weeklyBlockingSlots.forEach(weeklyBlockingSlot => {
            let slot = {
              dayId: parseInt(key),
              startSlot: weeklyBlockingSlot.startSlot,
              endSlot: weeklyBlockingSlot.endSlot,
              starttime: times[weeklyBlockingSlot.startSlot],
              endtime: times[weeklyBlockingSlot.endSlot],
              id: Math.random().toString(36).substr(2, 9)
            };
            slot.formatted_value = this.formatRecurringBlockedTimeslotBlock(slot);
            slots.push(slot);
          });
        });

        this.wall.recurringBlockedTimeslots = slots;
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// EditWalls.vue?cb744d3c